import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface TreeTableHeaderProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

/**
 * Column-header row inside a {@link TreeTableContainer}. Muted background +
 * bottom border, horizontally flex with small gap.
 */
export function TreeTableHeader({children, className, 'data-testid': testId}: TreeTableHeaderProps) {
    return (
        <div
            className={cn('flex items-center gap-2 bg-muted/40 border-b py-2 px-3', className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
